/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_All_Session_TimesInputs */

const vi_stocktake_filter_all_session_times = /** @type {(inputs: Stocktake_Filter_All_Session_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả phiên`)
};

/**

* @param {Stocktake_Filter_All_Session_TimesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_all_session_times = /** @type {((inputs?: Stocktake_Filter_All_Session_TimesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_All_Session_TimesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_all_session_times(inputs)
});